import { InternalApiApi } from './api'
import { createApiClient } from './http-client'

class StorageResetDataService {
  httpClient = createApiClient(InternalApiApi)

  async resetData() {
    await this.httpClient.internalApiResetData()
  }

  async saveSnapshot() {
    await this.httpClient.internalApiSaveDemoData()
  }
}

export default new StorageResetDataService()
